export default "__VITE_ASSET__FS6I5aYn__"